module.exports = __webpack_public_path__ + "static/media/chest-and-file-safes.d1b18c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/chest-and-file-safes.png
// module id = 1284
// module chunks = 0